import {Box, BoxProps} from "@mui/material"
import {FC} from "react"
import {makeStyles} from "tss-react/mui";

type IProps = BoxProps;

const useStyles = makeStyles()((theme) => ({
	itemContent: {
		borderRadius: "16px",
		textAlign: "left",
		overflow: "hidden",
		boxSizing: "border-box",
		height: "476px",
		width: "calc(25% - 15px)",
		maxWidth: "calc(25% - 15px)",
		background: theme.palette.background.paper,
		padding: "20px",
		flexGrow: 2,
		[theme.breakpoints.down("xl")]: {
			width: "calc(33.3% - 15px)",
			maxWidth: "340px"
		},
		[theme.breakpoints.down("md")]: {
			width: "calc(50% - 15px)"
		},
		[theme.breakpoints.down("sm")]: {
			width: "calc(100% - 15px)"
		}
	}
}));

export const TrainingFeedModuleSkeleton:FC<IProps> = ({className}) => {
	const {classes, cx} = useStyles();

	return (
		<Box className={cx(classes.itemContent, className)}>
		</Box>
	)
}